import moment from "moment";
import { DoctorReportDto } from "../../../api-client";

/**
 * Builds a human-readable description of the dispatch channels used for a
 * doctor report (per Post / per Fax / per Email + timestamp). Returns null
 * when no channel has a recorded timestamp.
 */
export const formatDispatchInfo = (
  report: Pick<DoctorReportDto, "printedAt" | "sentByFaxAt" | "sentByEmailAt"> | null | undefined,
): string | null => {
  if (!report) return null;
  const channels: string[] = [];
  if (report.printedAt) {
    channels.push(`per Post am ${moment(report.printedAt as any).format("DD.MM.YYYY")}`);
  }
  if (report.sentByFaxAt) {
    channels.push(`per Fax am ${moment(report.sentByFaxAt as any).format("DD.MM.YYYY HH:mm")}`);
  }
  if (report.sentByEmailAt) {
    channels.push(`per Email am ${moment(report.sentByEmailAt as any).format("DD.MM.YYYY HH:mm")}`);
  }
  return channels.length > 0 ? channels.join(", ") : null;
};
